import { render } from "./MeuPerfil.vue?vue&type=template&id=7db0f688&scoped=true"
import script from "./MeuPerfil.vue?vue&type=script&lang=js"
export * from "./MeuPerfil.vue?vue&type=script&lang=js"

import "./MeuPerfil.vue?vue&type=style&index=0&id=7db0f688&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db0f688"]])

export default __exports__